import { isManyOfManyPoll, isManyOfManyPollResponse, isOneOfManyPoll, isOneOfManyPollResponse } from '@tunasong/schemas'
import type { Poll, PollResponse } from '@tunasong/schemas'
import invariant from 'tiny-invariant'

/** Get the percentage progress of a poll option identified by idx */
export const getProgress = (poll: Poll, allResponses: PollResponse[], idx: number) => {
  let responsesForOption = 0
  const numResponses = allResponses.length

  if (isManyOfManyPoll(poll)) {
    const responses = allResponses.map(r => {
      invariant(isManyOfManyPollResponse(r), `Response must be a ManyOfManyPollResponse`)
      return r.choices
    })
    if (responses.length === 0) {
      return 0
    }
    responsesForOption = responses.filter(r => typeof r === 'object' && r[idx]).length
  } else if (isOneOfManyPoll(poll)) {
    responsesForOption = allResponses.filter(r => {
      invariant(isOneOfManyPollResponse(r), `Response must be a OneOfManyPollResponse`)
      return r.choice === idx
    }).length
  }

  /**
   * The many-of-many branch returns early at zero responses; the one-of-many branch fell
   * through to this division and rendered `NaN%`. Guard both.
   */
  if (numResponses === 0) {
    return 0
  }

  return (responsesForOption / numResponses) * 100
}
